  <template>
    <div class="ve-list-page ve-list-page--embedded">
        <div style=" background:#f7f8f9;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <span style="  font-size:12px;margin-right:10px;margin-left:5px;font-weight:600">{{ $LANG('0681', '字段查询') }}</span>
                <el-select @change="selChg" v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input v-if="v_bool" :placeholder="input_hold" clearable v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px;background:white;border:1px solid #389 " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <template slot ="append">
                        <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="inputQry" class="custom-button" ></el-button>
                    </template>
                </el-input> 
                <el-date-picker @change="inputQry" style="width:300px" size="small" value-format="yyyy-MM-dd" v-if="!v_bool"  v-model="txtArr1" type="daterange" :range-separator="$LANG('1657', '至')" :start-placeholder="$LANG('0021', '开始日期')"  :end-placeholder="$LANG('0913', '结束日期')">  </el-date-picker>


                <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                        
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="ve-list-page__body">
            <ve-table class="ve-list-page__table" :columns="vueCol"
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="PKSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="subHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                   
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :footer-data="footerData"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="prd_stkin_two"
                    ref="tableRef" >
            </ve-table>
            <div class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
  
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate,getDate2} from '../../api/Select' 
 
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
 
export default {
    name:'stk_init_two',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '115',
            fieldIdseq: '115',
            fieldLstseq: '3',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['ordno'],
        })
    ],
    data () {
        return {
            loadWin:false,
 
            v_row:{},
            v_table:'',
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            txtArr1:[],
            ruleValidate:{},
            v_bool:true,
            v_bool2:true,
            txtArr2:[],
            v_commit :true,
            promptWin:false,
            formRow:{},
            comboArr:[],
 
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            v_index:0,
            selparam:'IDNO',
            txtparam:'',
            mainRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            delBool:false,
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            v_clntno:'',
 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [100,500,1000],
            dataCount:0,
            pageSize:100,
            dtlCol:[],
            formCol:[],
            tabCol:[],
            operArr:[],
            szArr:[],
            prcData:[],
  
            oper:'like',
            v_key:'',
 
            dtlIndex:'',
            initCol:[],
            delDtlArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
            stfgColor:'',
            stfgCss:'',
 
            notNull:[],
            pageIndex:1,
            loadingInstance: null,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
            vueCol:[],
        }
    },
    components: {
      VeColumnConfigDialog,
      repWin,
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 185) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 330) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
 
         //用户权限表
        getBaseData('xuper_auth/getBaseData','userno',this.v_username,'frmidseq','115','v_sys_user_priv','').then(res=>{           
 
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISEXP==='N'){ //作废
                this.appBool=true
            }
 
        })    
 
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#prd_stkin_two"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.inputQry() //查询数据   
 
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        //表格行 按回车键 到下一行
        nextLine(key,val,refkey){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (refkey=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (refkey=='refpos'){
                        this.$refs['pos'+this.chkIndex+'RMK'][0].focus()  
                    } 
                }else{
                    if (refkey=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (refkey=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (refkey=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (refkey=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
 
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]))
               // console.log(column.property,'....')
                if( (column.property!==undefined && column.property.indexOf('SZ#')>-1) || column.property=='TTL'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
 
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'115',p_lstseq:'3',p_json:JSON.stringify(this.allList),p_action:'期初明细'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0114', '期初明细')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
 
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            }
        },
  
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        selChg(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool =false
                    }else{
                        this.v_bool =true
                    }
                }
            })
            this.txtArr1=[]
            this.txtparam1=''
        },
        selChg2(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool2 =false
                    }else{
                        this.v_bool2 =true
                    }
                }
            })
            this.txtArr2=[]
            this.txtparam2=''
        },
        //字段查询
        inputQry(){
            let cond_='' ,v_edcss='',v_edcss2=''
            if (this.selparam){ //列1
                this.tabCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (v_edcss =='date'){
                    if (this.txtArr1 )
                    cond_=cond_+' and '+this.selparam+' between \'' + this.txtArr1[0]+'\' and \''+ this.txtArr1[1]+'\''
                }else {
                    if (this.oper==='like'){
                        cond_=cond_+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                    }else if (this.oper==='!='){
                        cond_=cond_+' and  '+this.selparam+' is null '  
                    }else{
                        if (this.txtparam){
                            if (v_edcss=='number'){
                                if (this.oper ){
                                    cond_=cond_+' and  '+this.selparam  +this.oper+ this.txtparam
                                }else{
                                    cond_=cond_+' and '+this.selparam  +'='+ this.txtparam
                                }
                            }else {
                                cond_=cond_+' and '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                            }
                        }
                    }
                }
            }
 
            let v_cond ='' , v_oper='like' 
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (v_edcss =='number' ){
                        if (v_oper=='like'){
                            v_oper ='='
                        }
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_row[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                        }
                    }else{
                        
                        if (v_oper =='like'){
                            v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }else{
                            v_cond =v_cond +' and  '+item+'  =\''+ (this.v_row[item]).trim()+'\''
                        }
                        
                    }                   
                }
            })
            this.getTabList(cond_+v_cond)
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
 
        getRowKey(row){
            return row.index
        },
   
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
 
        },
        getFootSum(){
            let v_foot ={}
            const targetKeys = [ 'AMT','QTY' ]
            // 初始化累加器对象
            const initialAcc = targetKeys.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, {})
            // 单次 reduce 计算所有总和
            const totals = this.allList.reduce((acc, cur) => {
                targetKeys.forEach(key => {
                    // 累加当前 key 的值，处理 undefined/null 情况
                    acc[key] += Number(cur[key]) || 0
                });
                return acc
            }, initialAcc)
            // 格式化并赋值
            targetKeys.forEach(key => {
                const val = totals[key];
                v_foot[key] = val > 0 ? val.toLocaleString() : '';
            })
            let v_obj =Object.assign({
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                }, v_foot)
            this.footerData =[  v_obj ]
        } , 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            this.getFootSum()
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
            this.getFootSum()
        },
        //查询界面 
        getTabList(cond){    
            this.loadingInstance.show() 
            return getTabColOrData(this.v_url,'V_IC_STKDTL_QRY','IDTY','INIT','corpid',this.v_corpid,'','',cond +' order by '+this.selparam+' desc').then((res) => {
                const result =res && res.result
                this.allList =Array.isArray(result) ? result : []
                if (!Array.isArray(result)){
                    this.promptWin =true
                    this.prompt =typeof result ==='string' && result ? result : this.$LANG('1641', '查询失败')
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.loadingInstance.close() 
                }) 
                this.initPage() 
            }).catch((error) => {
                this.allList =[]
                this.initPage()
                this.loadingInstance.close()
                this.promptWin =true
                this.prompt =error.message || this.$LANG('1641', '查询失败')
            })
      
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            this.vueCol =[]
            this.tabCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','115','lstseq','3','','',' order by sortby,lstseq' ).then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then(() => {
                this.vueCol =[]
                this.tabCol =[]
                const mainFields =this.sortFieldRows(this.initCol)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        holder:rowField.HOLDER,
                        sortable:rowField.SORTABLE,
                        fix:rowField.ISFIX,
                    })
                    let itcol =rowField
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex;height:28px;"> 
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option    value="="  >=</option>
                                                    <option    value=">"  >&gt;</option>
                                                    <option    value="<"  >&lt;</option>
                                                    <option    value="!="  >!=</option>
                                                </select>                                             
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini" placeholder="" style="width:100%" on-change={()=>this.inputQry() }  ></el-date-picker>
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="="  >=</option>
                                                        <option    value=">"  >&gt;</option>
                                                        <option    value="<"  >&lt;</option>
                                                        <option    value="!="  >!=</option>
                                                    </select>                                                 
                                                    <el-input placeholder="" disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        if (itcol.EDCSS=='checkbox'){
                                            return (                              
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                    </div>  
                                                    <div style="display:flex">
                                                        <el-select size="mini" placeholder="" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.inputQry()}}>
                                                            <el-option  value="Y" label={this.$LANG('2047', '是')} ></el-option>
                                                            <el-option  value="N"  label={this.$LANG('2044', '否')} ></el-option>
                                                        </el-select>                                                          
                                                    </div>
                                                </div>                                   
                                            )    
                                        }else {
                                            return (                              
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                    </div>  
                                                    <div style="display:flex">
  
                                                        <input disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}}  on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                    </div>
                                                </div>                                 
                                            )
                                        }
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (column.key=='ORDSTFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //procShow(scope.row)
                                        return (
                                            <el-link   on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                        )
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
 
                this.vueCol.unshift(v_rownum) 
                this.applyFieldSettingRows()
 
            })
 
 
        },
    }
}
</script>
<style scoped lang="less">
    .custom-append {
        width: 40px; /* 设置你想要的宽度 */
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        background-color: #fff;
        border-left: 1px solid #3d6fe2;
        padding: 0 5px;
    }
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
 
    .ve-table-footer-tr{
        height:30px !important;
    }
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
 
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .default-row {
        color:black;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-table .green-row  {
        color: green;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
